module.exports = __webpack_public_path__ + "static/17-e465a7f14e4ce4f3224a60808c5d1470.png";